<!-- PRINT -->
<a *ngIf="print" href="javascript:void(0)" class="btn btn-added" (click)="printRecords()" [class.disabled]="data.length === 0" [attr.aria-disabled]="data.length === 0 ? 'true' : null">
  Print
</a>

<!-- PDF download -->
<a *ngIf="downloadPdf" href="javascript:void(0)" (click)="downloadPDF()" [class.disabled]="data.length === 0" [attr.aria-disabled]="data.length === 0 ? 'true' : null" class="text-black">
  PDF
</a>
